import swEduVolunteerImage from "../assets/sw교육봉사.jpeg";
import informationProcessingEngineer from "../assets/정보처리기사.jpg";
import diploma from "../assets/졸업.jpg";
import sqld from "../assets/SQLD.png";

export const experiences = [
  {
    title: "SW 교육 봉사",
    date: "2022.07.25 ~ 2022.07.29",
    type: "file",
    imgSrc: swEduVolunteerImage,
  },
  {
    title: "정보처리기사 취득",
    date: "2024.06.18",
    type: "file",
    imgSrc: informationProcessingEngineer,
  },
  {
    title: "구름톤 딥 다이브 프론트엔드 1기",
    date: "2024.08.19 ~ 2025.04.02",
    type: "github",
    link: "https://github.com/hjoo830/9oormthon-DEEP-DIVE",
  },
  {
    title: "영남대학교 컴퓨터공학과 졸업",
    date: "2025.02.21",
    type: "file",
    imgSrc: diploma,
  },
  {
    title: "SQLD 취득",
    date: "2025.04.04",
    type: "file",
    imgSrc: sqld,
  },
];
